import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as productionOrderSelectors, actions as productionOrderActions } from 'ducks/salesOrderEnquiry/committedProductionOrder';
import { fetch } from 'api/salesOrderEnquiry/committedProductionOrder';
import { selectors as orderSelectors } from 'ducks/salesOrderEnquiry/salesOrder';

export const mapStateToProps = state => {
  const params = new URLSearchParams(location.search);

  return ({
    gridName: 'CommittedProductionOrder',
    columnDefs: productionOrderSelectors.Columns(state),
    isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state), //to trigger update size based on drawer state change
    actions: productionOrderSelectors.Actions(state),
    gridOptions: productionOrderSelectors.gridOptions(state),
    isLoading: productionOrderSelectors.isLoading(state),
    reqParams: orderSelectors.selected(state) || params.get('SalesOrder') &&
    {
      SalesOrder: (orderSelectors.selected(state) && orderSelectors.selected(state).SalesOrder) || params.get('SalesOrder'),
    },
    apiMethod: fetch
  });
}

export const actions = {
  deleteSelectedRecords: productionOrderActions.remove,
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: productionOrderActions.setSelected
}
